// extracted by mini-css-extract-plugin
module.exports = {"join":"OnjO7bw"};